<template>
  <div>
    <div class="col-sm-6">
      <div class="h-title">{{$t('Topo.neList')}}</div>
      <div class="e-input-group m-b-8">
        <ejs-textbox :placeholder="$t('Security.auth.search')" v-model="keyword" :change="search">
          <span class="icon hero-icon hero-icon-search"></span>
        </ejs-textbox>
      </div>
      <ejs-listview ref='neListView' cssClass='h-security-role-leftTree' :dataSource='neDatas' :fields='neFieldModel' @select='neSelected'></ejs-listview>
    </div>
    <div class="col-sm-6">
      <div class="h-title">{{$t('SubscriberIms.organization')}}</div>
      <div class="tree-box h-security-role-rightTree">
        <tree
          :setting="vpnAuthSetting"
          :nodes="vpnAuthNodes"
          @onCreated="handleVpnAuthCreated"
          @onCheck="checkVpnNode"/>
      </div>
    </div>
  </div>
</template>

<script>
import tree from 'vue-giant-tree'
import mixin from '../../../mixin/mixin';
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "AddRoleP4",
  components: {
    tree
  },
  mixins: [mixin],
  data() {
    return {
      checked: [],
      keyword: "",
      roleId: '',
      vpnIdChecked: {},
      neFieldModel: {
        text: 'name',
        value: 'id'
      },
      neDatas: [],
      neDatasConst: [],
      neid: 0,
      vpnAuthTreeObj: '',
      vpnAuthSetting: {
        data: {
          key: {
            name: 'name'
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pid',
            rootPId: ''
          }
        },
        check: {
          chkboxType: { 'Y': '', 'N':'' },
          chkStyle: 'checkbox',
          enable: true
        }
      },
      vpnAuthNodes: [],
      queryOrg: 'getVpnTreeFromIms',
      phss:[23,2142]
    };
  },
  methods: {
    search(){
      // 前台过滤
      if (this.keyword.trim() == '') {
        this.neDatas = this.neDatasConst;
      }
      const temp = this.neDatasConst.filter(item => item.name.indexOf(this.keyword.trim()) != -1);
      this.neDatas = temp;
    },
    getNeList() {
      const url = "/lte/ems/auth/findElementList";
      const params = this.phss; // p_hss
      this.axios.post(url, params).then(response => {
        let temp = response.data;
        let neMap = {};
        temp.forEach(item => {
          if (!neMap.hasOwnProperty(item.clusterId)) {
            neMap[item.clusterId] = item;
          }
        });
        temp = []
        for (var i in neMap) {
          temp.push(neMap[i])
        }
        this.neDatas = temp;
        this.neDatasConst = this.neDatas;
      });
    },
    neSelected(args) {
      EventBus.$emit('loading', {ison:true})
      let typeCode = args.data.typeCode;
      this.neid = args.data.id;
      let url = '/lte/ems/subscriber/imsunms/requestCommon';
      let params = {
        vo: { 0: this.neid },
        info: {
          neid: this.neid,
          operation: this.queryOrg
        }
      };
      if (typeCode==2142){
        url = '/lte/ems/subscriber/mcs/requestCommonMicro';
        let oper_param = 'getVpnTreeWithNeid';
        params = {
          vo: { 0: {
            info: {msgid: 46103, productType: 1, enterpriseDomain: 'mcs.com', neid: [this.neid]},
            page: {pageNo: 1, pageSize: 20000},
            vo: {enterpriseDomain: 'mcs.com', flag: 0, productType: 1, vpnId: '', neid: [this.neid]}
            } },
          info: {
            msgid: 46103,
            neid: [this.neid],
            operation: oper_param
          }
        }
      }
      this.axios.post(url, params).then(response => {
        const vpnStr = response.data.resultVal;
        let result = [];
        if (vpnStr!=null) {
          result = JSON.parse(vpnStr);
        }
        if (typeCode==2142) {
          // 特殊处理数据
          result = this.convertGmsData(result, 0)
        }
        result = result.filter(item => {
          return item.id != 0;
        }).map(item => {
          item['id_show'] = this.neid + '_7_' + item.id
          return item
        })
        result.push({
          'id_show': this.neid + '_7_' + 0,
          'id': 0,
          'name': `${this.$t('SubscriberIms.organization')}`,
          'pid': 0
        })
        this.vpnAuthNodes = result;
        EventBus.$emit('loading', {ison:false})
      });
    },
    convertGmsData(data, pid) {
      let list = [];
      data.forEach(item => {
        if(!!item.children) {
          list = list.concat(this.convertGmsData(item.children, item.id));
        }
        let node = {
          'id_show': this.neid + '_7_' + item.id,
          'id': item.id,
          'name': item.name,
          'pid': pid
        };
        list.push(node)
      });
      return list;
    },
    setVpnCheck() {
      if (!!this.vpnIdChecked[this.neid]) {
        this.vpnIdChecked[this.neid].forEach(item => {
          let treeNode = this.vpnAuthTreeObj.getNodeByParam('id_show', item)
          const subNodes = treeNode.children
          let subCheckedNodes = this.vpnAuthTreeObj.getNodesByParam('checked', true, treeNode)
          this.vpnAuthTreeObj.checkNode(treeNode, true, false, false)
          this.cancelCheckedNodes(subCheckedNodes)
          this.disabledNodeCheck(subNodes, true)
        })
      }
    },
    checkVpnNode(event, treeId, treeNode) {
      const subNodes = treeNode.children
      const disabledStatus = treeNode.checked
      let subCheckedNodes = this.vpnAuthTreeObj.getNodesByParam('checked', true, treeNode)
      this.cancelCheckedNodes(subCheckedNodes)
      this.disabledNodeCheck(subNodes, disabledStatus)
      this.setChildProps()
    },
    cancelCheckedNodes(subCheckedNodes) {
      if (!!subCheckedNodes) {
        subCheckedNodes.forEach(node => {
          this.vpnAuthTreeObj.checkNode(node, false, false, false)
        });
      }
    },
    disabledNodeCheck(subNodes, disabledStatus) {
      if (!!subNodes) {
        subNodes.forEach(node => {
          this.vpnAuthTreeObj.setChkDisabled(node, disabledStatus, false, true)
        });
      }
    },
    handleVpnAuthCreated(ztreeObj) {
      this.vpnAuthTreeObj = ztreeObj
      this.vpnAuthTreeObj.expandAll(true)
      this.setVpnCheck()
    },
    setChildProps() {
      let checkedVpnNode = this.vpnAuthTreeObj.getNodesByParam('checked', true)
      let vpnIds = []
      checkedVpnNode.forEach(node => {
        vpnIds.push(node.id_show)
      })
      this.vpnIdChecked[this.neid] = vpnIds;
      this.$emit("childProps", {
        vpnIdList: this.vpnIdChecked
      });
    },
    init(roleParams) {
      this.roleId = roleParams.roleId;
      this.vpnIdChecked = roleParams.vpnIdList;
      this.$emit("childProps", {
        vpnIdList: this.vpnIdChecked
      });
    }
  }
};
</script>
